<script>
export default ({
  name: 'SupplierLogo',
  props: ['supplier'],
  data() {
    return {
      imgError: false,
    };
  },
  computed: {
    supplierLogoPath() {
      try {
        const filename = `${this.supplier.toLowerCase().replace(/[- _]/g, '')}.png`;
        return require(`images/suppliers/${filename}`);
      } catch (e) {
        this.imgError = true;
      }
    },
  },
});
</script>

<template>
  <div v-if="imgError">
    <div>{{ supplier }}</div>
  </div>
  <div v-else>
    <img :src="supplierLogoPath" :alt="supplier" class="h-6" />
  </div>
</template>
